import { createSelector } from '@ngrx/store';
import { IotAssetState } from './iotAsset.reducer';

// Selettore di base per ottenere lo stato degli IoT Assets
export const selectIotAssetState = (state: { iotAssets: IotAssetState }) => state.iotAssets;

// Selettore per ottenere tutti gli IoT Assets
export const selectIotAssets = createSelector(
  selectIotAssetState,
  (state: IotAssetState) => state.iotAssets
);

// Selettore per ottenere lo stato di caricamento
export const selectIsLoading = createSelector(
  selectIotAssetState,
  (state: IotAssetState) => state.isLoading
);

// Selettore per ottenere lo stato di aggiornamento
export const selectIsRefreshing = createSelector(
  selectIotAssetState,
  (state: IotAssetState) => state.isRefreshing
);

// Selettore per ottenere il totale generale degli asset
export const selectTotalAssets = createSelector(
  selectIotAssetState,
  (state: IotAssetState) => state.totalAssets
);

// Selettori per la configurazione di mapping
export const selectMappingConfig = createSelector(
  selectIotAssetState,
  (state: IotAssetState) => state.mappingConfig
);

export const selectConfigLoading = createSelector(
  selectIotAssetState,
  (state: IotAssetState) => state.configLoading
);

export const selectConfigError = createSelector(
  selectIotAssetState,
  (state: IotAssetState) => state.configError
);

// Selettore per ottenere gli asset con configurazione applicata
export const selectIotAssetsWithConfig = createSelector(
  selectIotAssets,
  selectMappingConfig,
  (assets, config) => {
    if (!config || !config.fields) {
      return assets;
    }
    
    // Applica la configurazione agli asset
    return assets.map(asset => {
      const processedAsset = { ...asset };
      
      // Applica la visibilità dei campi
      Object.keys(config.fields).forEach(field => {
        const fieldConfig = config.fields[field];
        if (fieldConfig.visible === false && processedAsset.hasOwnProperty(field)) {
          delete processedAsset[field];
        }
      });
      
      return processedAsset;
    });
  }
);

// Selettore per ottenere gli asset selezionati
export const selectSelectedIotAssets = createSelector(
  selectIotAssets,
  (assets) => assets.filter(asset => asset.vehicle_selected)
);
